import api from "./axios";

export const listMyAssignedTickets = (params = {}) =>
  api.get("/my/assigned-tickets", { params });
export const getMyAssignedTicket = (id) => api.get(`/my/assigned-tickets/${id}`);
export const sendMyAssignedTicketMessage = (id, message) =>
  api.post(`/my/assigned-tickets/${id}/messages`, { message });
export const updateMyAssignedTicketStatus = (id, status) =>
  api.patch(`/my/assigned-tickets/${id}/status`, { status });
